export default __webpack_public_path__ + "static/media/icon.2c43725b.png";